// src/utils/leaflet.js
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet default icon issue
export function setupLeafletIcons() {
  // Delete the default icon getter
  delete L.Icon.Default.prototype._getIconUrl;
  
  // Set the default icon URLs
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  });
}

// Export a custom icon creator
export function createCustomIcon(iconUrl, iconSize = [25, 41], iconAnchor = [12, 41]) {
  return new L.Icon({
    iconUrl,
    iconSize,
    iconAnchor,
    popupAnchor: [0, -41],
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
    shadowSize: [41, 41],
  });
}

// Export default L for convenience
export default L;
